import memoize from "lodash-es/memoize";

import { IBreakpoints, BreakpointsTypes, DirectionType } from "../../interfaces/IBreakpoints";
import { BREAKPOINTS_WIDTH, BREAKPOINTS_HEIGHT } from "../../constants";

const breakpoints = [
    BreakpointsTypes.XXL,
    BreakpointsTypes.XL,
    BreakpointsTypes.L,
    BreakpointsTypes.M,
    BreakpointsTypes.S,
    BreakpointsTypes.XS,
    BreakpointsTypes.XXS,
];

const getBreakpointsArray = map => breakpoints.map((key: BreakpointsTypes) => [key, map[key]]);

const BREAKPOINTS_MAP_WIDTH = getBreakpointsArray(BREAKPOINTS_WIDTH);
const BREAKPOINTS_MAP_HEIGHT = getBreakpointsArray(BREAKPOINTS_HEIGHT);

const getPointsObject = (): IBreakpoints => {
    const result = {};

    breakpoints.forEach((key: BreakpointsTypes) => {
        result[key] = false;
    });

    return result as IBreakpoints;
}

export const calcBreakpoints = memoize(
    (variable: number, type: DirectionType): IBreakpoints => {
        const breakpoints = getPointsObject();
        const map = type === DirectionType.HEIGHT ? BREAKPOINTS_MAP_HEIGHT : BREAKPOINTS_MAP_WIDTH;
        for (const [key, value] of map) {
            if (variable >= value) {
                breakpoints[key] = true;
                return breakpoints;
            }
        }
    }
);
